module.exports = __webpack_public_path__ + "img/molden.c24bfe89.svg";